module.exports = __webpack_public_path__ + "static/cloud-ea9cfac857116e8e0710d53585be8dac.png";